// Application constants

// Default study ID for local development
// TODO: Replace with dynamic study selection when implemented
export const DEFAULT_STUDY_ID = 90;

// Feature flags
export const ENABLE_EXTENDED_FILE_UPLOAD_FEATURES =
  import.meta.env.VITE_ENABLE_EXTENDED_FILE_UPLOAD_FEATURES === 'true';

// API configuration
export const API_ENDPOINTS = {
  STUDY_FILES: 'v1/study_files',
  STUDY_FILES_VALIDATE_META: 'v1/study_files/validate_meta',
  STUDY_FORMS: 'v1/study_forms',
  WHITELISTED_STUDY_FILES: 'v1/whitelisted_study_files',
  WHITELISTED_STUDY_FILES_VALIDATE_META:
    'v1/whitelisted_study_files/validate_meta',
  CSV_FILES: 'v1/csv_files',
  CSV_FILES_VERSIONS: 'v1/csv_files/versions',
  EVENT_TRAILS: 'v1/event_trails',
  IMPORT_MAPPINGS: 'v1/import_mappings',
  USERS: 'v1/users',
  AUTH: 'auth',
  LOGIN: 'auth/login',
  LOGOUT: 'auth/logout',
  REFRESH_TOKEN: 'auth/refresh_token',
  USER_PROFILE: 'v1/users/profile',
  WHITELISTS: 'v1/whitelists',
  WHITELISTS_VERSIONS: 'v1/whitelists/versions',
} as const;

// Centralized download endpoint generators
// Note: These endpoints are relative to the api baseURL (which already includes /api)
export const DOWNLOAD_ENDPOINTS = {
  // Study Files
  studyFile: (fileId: number, versionId?: number) => {
    const version = versionId || 'latest';
    return `/v1/study_files/${fileId}/versions/${version}/download`;
  },

  studyFileVersion: (fileId: number, versionId: number) => {
    return `/v1/study_files/${fileId}/versions/${versionId}/download`;
  },

  // CSV Files
  csvFile: (fileId: number, versionId?: number) => {
    const version = versionId || 'latest';
    return `/v1/csv_files/${fileId}/versions/${version}/download`;
  },

  csvFileVersion: (fileId: number, versionId: number) => {
    return `/v1/csv_files/${fileId}/versions/${versionId}/download`;
  },

  // Whitelists
  whitelist: (fileId: number, versionId?: number) => {
    const version = versionId || 'latest';
    return `/v1/whitelists/${fileId}/versions/${version}/download`;
  },

  whitelistVersion: (fileId: number, versionId: number) => {
    return `/v1/whitelists/${fileId}/versions/${versionId}/download`;
  },

  // Whitelisted Study Files
  whitelistedStudyFile: (fileId: number, versionId?: number) => {
    const version = versionId || 'latest';
    return `/v1/whitelisted_study_files/${fileId}/versions/${version}/download`;
  },

  whitelistedStudyFileVersion: (fileId: number, versionId: number) => {
    return `/v1/whitelisted_study_files/${fileId}/versions/${versionId}/download`;
  },
} as const;
